<div ngbDropdown
     display="dynamic"
     placement="bottom-right">
  <button ngbDropdownToggle
          class="btn btn-primary-outline border-0 btn-sm"
          type="button">
    <fa-icon icon="trash"></fa-icon>
  </button>

  <div ngbDropdownMenu>
    <!-- Delete Location -->
    @if (location(); as location) {
      <button ngbDropdownItem
              type="button"
              (click)="openDeleteLocationModal()">
        <fa-icon icon="trash"></fa-icon>
        Location {{ location.HotelCode }}
      </button>
    }

    <!-- Delete Room -->
    @if (room(); as room) {
      <button ngbDropdownItem
              type="button"
              (click)="openDeleteRoomModal()">
        <fa-icon icon="trash"></fa-icon>
        Room {{ room.Room }}
      </button>
    }
  </div>
</div>